import { render, staticRenderFns } from "./UpdateWaitingListStatus.vue?vue&type=template&id=71547adb"
import script from "./UpdateWaitingListStatus.vue?vue&type=script&lang=js"
export * from "./UpdateWaitingListStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports